import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Home from './Pages/Home';

import AboutUs from './Pages/AboutUs';
import ContactUs from './Pages/ContactUs';

import NewsGrid from './Pages/NewsGrid';
import NewsListing from './Pages/NewsListing';
import Projects from './Pages/Projects';

import ProjectDetail from './Pages/ProjectDetail';
import WorkCarousel from './Pages/WorkCarousel';
import WorkGrid from './Pages/WorkGrid';
import WorkMasonary from './Pages/WorkMasonary';

import PostGallery from './Pages/PostGallery';
import PostImage from './Pages/PostImage';
import PostRightSidebar from './Pages/PostRightSidebar';
import PostVideo from './Pages/PostVideo';

import Accordian from './Pages/Accordian';
import AlertBox from './Pages/AlertBox';
import Button from './Pages/Button';
import Carousel from './Pages/Carousel';
import ClientLogo from './Pages/ClientLogo';
import Counter from './Pages/Counter';
import GoogleMap from './Pages/GoogleMap';
import IconBox from './Pages/IconBox';
import ListGroup from './Pages/ListGroup';
import ModalPopup from './Pages/ModalPopup';
import Tabs from './Pages/Tabs';
import Video from './Pages/Video';

class Components extends React.Component {
    render() {
        return (
            <BrowserRouter basename="/">
                <div className="page-wraper">
                        <Switch>
                            <Route path='/' exact component={Home} />

                            <Route path='/aboutus' exact component={AboutUs} />
                            <Route path='/contactus' exact component={ContactUs} />

                            <Route path='/news-grid' exact component={NewsGrid} />
                            <Route path='/news-listing' exact component={NewsListing} />
                            <Route path='/projects/:id' exact component={Projects} />

                            <Route path='/work-grid' exact component={WorkGrid} />
                            <Route path='/work-masonary' exact component={WorkMasonary} />
                            <Route path='/work-carousel' exact component={WorkCarousel} />
                            <Route path='/project-detail' exact component={ProjectDetail} />

                            <Route path='/post-image' exact component={PostImage} />
                            <Route path='/post-gallery' exact component={PostGallery} />
                            <Route path='/post-video' exact component={PostVideo} />
                            <Route path='/post-right-sidebar' exact component={PostRightSidebar} />

                            <Route path='/accordian' exact component={Accordian} />
                            <Route path='/alertbox' exact component={AlertBox} />
                            <Route path='/button' exact component={Button} />
                            <Route path='/carousel' exact component={Carousel} />
                            <Route path='/logoslider' exact component={ClientLogo} />
                            <Route path='/counter' exact component={Counter} />
                            <Route path='/googlemap' exact component={GoogleMap} />
                            <Route path='/iconbox' exact component={IconBox} />
                            <Route path='/lisgroup' exact component={ListGroup} />
                            <Route path='/modalpopup' exact component={ModalPopup} />
                            <Route path='/tabs' exact component={Tabs} />
                            <Route path='/video' exact component={Video} />
                            
                            <Route component={Error} />
                            
                            <Route component={Error} />
                        </Switch>
                </div>
            </BrowserRouter>
        );
    };
};

export default Components;